import i18n from 'utils/i18n'
import type { MyReviewsFiltersConfig } from 'components/Common/Table/Layout/Page/_methods/types'
import {
  filterTypes,
  CHECKBOX_LIST,
  DATE_INTERVAL,
  SCORE,
  SWITCHER,
  RHEOSTAT,
  SEARCH_USERS,
  MULTISELECT_SWITCHER,
  myReviewsFiltersTitle,
  myReviewsFiltersName,
  myReviewsFiltersKey,
} from 'utils/consts'

export const getMyReviewsFiltersCollection = () => [
  {
    type: filterTypes[SEARCH_USERS],
    title: i18n.t(myReviewsFiltersTitle.usersFilter),
    filterName: myReviewsFiltersName.usersFilter,
    apiFilterName: myReviewsFiltersKey().usersFilter,
  },
  {
    type: filterTypes[RHEOSTAT],
    title: i18n.t(myReviewsFiltersTitle.drinkingWindowFilter),
    filterName: myReviewsFiltersName.drinkingWindowFilter,
    apiFilterName: myReviewsFiltersKey().drinkingWindowFilter,
    step: 1,
    defaultIntervalKey: 'drinkingWindow',
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(myReviewsFiltersTitle.bottleSizeFilter),
    filterName: myReviewsFiltersName.bottleSizeFilter,
    apiFilterName: myReviewsFiltersKey().bottleSizeFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(myReviewsFiltersTitle.packageTypeFilter),
    filterName: myReviewsFiltersName.packageTypeFilter,
    apiFilterName: myReviewsFiltersKey().packageTypeFilter,
  },
  {
    type: filterTypes[DATE_INTERVAL],
    title: i18n.t(myReviewsFiltersTitle.createdAtFilter),
    filterName: myReviewsFiltersName.createdAtFilter,
    apiFilterName: myReviewsFiltersKey().createdAtFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(myReviewsFiltersTitle.producerFilter),
    filterName: myReviewsFiltersName.producerFilter,
    apiFilterName: myReviewsFiltersKey().producerFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(myReviewsFiltersTitle.brandFilter),
    filterName: myReviewsFiltersName.brandFilter,
    apiFilterName: myReviewsFiltersKey().brandFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(myReviewsFiltersTitle.countryFilter),
    filterName: myReviewsFiltersName.countryFilter,
    apiFilterName: myReviewsFiltersKey().countryFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(myReviewsFiltersTitle.wineRegionEUFilter),
    filterName: myReviewsFiltersName.wineRegionEUFilter,
    apiFilterName: myReviewsFiltersKey().wineRegionEUFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(myReviewsFiltersTitle.euGITypeFilter),
    filterName: myReviewsFiltersName.euGITypeFilter,
    apiFilterName: myReviewsFiltersKey().euGITypeFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(myReviewsFiltersTitle.nationalGITypeFilter),
    filterName: myReviewsFiltersName.nationalGITypeFilter,
    apiFilterName: myReviewsFiltersKey().nationalGITypeFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(myReviewsFiltersTitle.geoIndicationFilter),
    filterName: myReviewsFiltersName.geoIndicationFilter,
    apiFilterName: myReviewsFiltersKey().geoIndicationFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(myReviewsFiltersTitle.specialClassificationFilter),
    filterName: myReviewsFiltersName.specialClassificationFilter,
    apiFilterName: myReviewsFiltersKey().specialClassificationFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(myReviewsFiltersTitle.wineColourFilter),
    filterName: myReviewsFiltersName.wineColourFilter,
    apiFilterName: myReviewsFiltersKey().wineColourFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(myReviewsFiltersTitle.wineTypeFilter),
    filterName: myReviewsFiltersName.wineTypeFilter,
    apiFilterName: myReviewsFiltersKey().wineTypeFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(myReviewsFiltersTitle.sweetnessTypeFilter),
    filterName: myReviewsFiltersName.sweetnessTypeFilter,
    apiFilterName: myReviewsFiltersKey().sweetnessTypeFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(myReviewsFiltersTitle.vintageFilter),
    filterName: myReviewsFiltersName.vintageFilter,
    apiFilterName: myReviewsFiltersKey().vintageFilter,
  },
  {
    type: filterTypes[MULTISELECT_SWITCHER],
    title: i18n.t(myReviewsFiltersTitle.grapesFilter),
    filterName: myReviewsFiltersName.grapesFilter,
    apiFilterName: myReviewsFiltersKey().grapesFilter,
    switchType: filterTypes[SWITCHER],
    switchFilterName: myReviewsFiltersName.monocepageFilter,
    switchTitle: i18n.t(myReviewsFiltersTitle.monocepageFilter),
    switchApiFilterName: myReviewsFiltersKey().monocepageFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(myReviewsFiltersTitle.additionalInfoFilter),
    filterName: myReviewsFiltersName.additionalInfoFilter,
    apiFilterName: myReviewsFiltersKey().additionalInfoFilter,
  },
  {
    type: filterTypes[RHEOSTAT],
    title: i18n.t(myReviewsFiltersTitle.alcoholLevelFilter),
    filterName: myReviewsFiltersName.alcoholLevelFilter,
    apiFilterName: myReviewsFiltersKey().alcoholLevelFilter,
    defaultIntervalKey: 'alcoholLevels',
  },
  {
    type: filterTypes[SCORE],
    title: i18n.t(myReviewsFiltersTitle.wwlRatingFilter),
    filterName: myReviewsFiltersName.wwlRatingFilter,
    apiFilterName: myReviewsFiltersKey().wwlRatingFilter,
  },
  {
    type: filterTypes[DATE_INTERVAL],
    title: i18n.t(myReviewsFiltersTitle.samplingDateFilter),
    filterName: myReviewsFiltersName.samplingDateFilter,
    apiFilterName: myReviewsFiltersKey().samplingDateFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(myReviewsFiltersTitle.venueTypeFilter),
    filterName: myReviewsFiltersName.venueTypeFilter,
    apiFilterName: myReviewsFiltersKey().venueTypeFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(myReviewsFiltersTitle.recognitionStatusFilter),
    filterName: myReviewsFiltersName.recognitionStatusFilter,
    apiFilterName: myReviewsFiltersKey().recognitionStatusFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(myReviewsFiltersTitle.statusFilter),
    filterName: myReviewsFiltersName.statusFilter,
    apiFilterName: myReviewsFiltersKey().statusFilter,
  },
]

export const myReviewsFiltersConfig: MyReviewsFiltersConfig = {
  component: 'myReviews',
  getFiltersCollection: getMyReviewsFiltersCollection,
  filtersDataPath: ['wineReviewsFilters'],
  showResultsTextKey: 'filters.button.apply',
}

export const adminReviewsFiltersConfig: MyReviewsFiltersConfig = {
  component: 'myReviews',
  getFiltersCollection: getMyReviewsFiltersCollection,
  filtersDataPath: ['admin', 'wineReviews', 'reviewsFilters'],
  showResultsTextKey: 'filters.button.apply',
}
